var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application"},[_c('WeatherData',{attrs:{"markers":_vm.markers}}),_c('Map',{on:{"update-weather-marker":_vm.updateWeatherMarker}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }